import React from "react";
import PropTypes from "prop-types";
import { Select } from "antd";

const SelectOption = Select.Option;

class KeyBankAccountSwitcher extends React.Component {
    state = {
        oldKeyAccountId: (
            this.props.bankAccounts.find(_ => _.is_key_account) || {
                id: null
            }
        ).id
    };

    changeKeyAccount = id => {
        this.setState({
            newKeyAccountId: id
        });
    };
    componentDidUpdate() {
        const oldKeyId = (
            this.props.bankAccounts.find(_ => _.is_key_account) || {
                id: null
            }
        ).id;
        if (!this.state || (!this.state.oldKeyAccountId && oldKeyId)) {
            this.setState({
                oldKeyAccountId: oldKeyId
            });
        }
    }
    render() {
        if (this.props.bankAccounts && this.props.bankAccounts.size) {
            return (
                <Select
                    style={{ minWidth: "400px" }}
                    onChange={this.changeKeyAccount}
                >
                    {this.props.bankAccounts
                        .map(_ => (
                            <SelectOption key={_.id} value={_.id}>
                                {_.account_holder_name} |{" "}
                                {_.bank_branch && _.bank_branch.bank_name}
                            </SelectOption>
                        ))
                        .toList()
                        .toArray()}
                </Select>
            );
        }
        return null;
    }
}

KeyBankAccountSwitcher.propTypes = {
    bankAccounts: PropTypes.object
};

export default KeyBankAccountSwitcher;
